import { FC } from 'react';
import { observer } from 'mobx-react';

import { Form, Stack, Text } from '@servicetitan/design-system';
import { EditorProps, getEditableCell, TableCellProps } from '@servicetitan/table';

import { PhoneData } from '../types/phone-data';

const Viewer: FC<TableCellProps<PhoneData>> = ({ dataItem, field, tableState }) => {
    if (!tableState || !field) {
        return <td>-</td>;
    }

    const displayValue = dataItem[field] || '-';

    return (
        <td>
            <Stack alignItems="center">
                <Text el="span" size={2}>
                    {displayValue}
                </Text>
            </Stack>
        </td>
    );
};

const Editor = observer(({ fieldState, tableState }: EditorProps<string>) => {
    if (!tableState) {
        return <td />;
    }

    return (
        <td>
            <Form.Input
                width={12}
                size="small"
                value={fieldState.value}
                onChange={(e: any) => fieldState.onChange(e.target.value)}
                error={fieldState.error}
            />
        </td>
    );
});

export const ForwardToCell = getEditableCell({
    viewer: Viewer,
    editor: Editor,
});
